import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap, Params, Router} from "@angular/router";
import {AuthService} from "../../services/auth.service";
import {MessageService} from "primeng/api";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  private static SAMLART = "SAMLart";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private messageService: MessageService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(
      (params: Params) => {
        let samlArt = params[LoginComponent.SAMLART];
        if (samlArt) {
          if (this.authService.isAuthenticated()) {
            this.router.navigate(['/home']);
          } else {
            this.authService.login(samlArt).subscribe(
              (next) => this.router.navigate(['/choose-form']),
              (error) => {
                this.messageService.add({
                    severity: 'error',
                    detail: "Nie udało się zalogować w Profilu Zaufanym"
                  }
                );
                this.router.navigate(['/home']);
              }
            );
          }
        } else {
          this.messageService.add({
            severity:'error',
            detail: "Nie udało się zalogować w Profilu Zaufanym"}
          );
          this.router.navigate(['/home']);
        }
      }
    );
  }
}
